import { motion } from "framer-motion";
import { INTEGRATION_LOGOS } from "../constants/logos";
import { IntegrationLogo } from "../shared/IntegrationLogo";

export const IntegrationCarousel = () => {
  return (
    <>
      {/* Mobile: Static Grid */}
      <section className="md:hidden px-5 mt-auto pb-8">
        <p className="text-xs font-medium tracking-widest uppercase text-muted-foreground mb-6">
          Integrations
        </p>
        <div className="grid grid-cols-3 gap-x-4 gap-y-6">
          {INTEGRATION_LOGOS.map((logo, index) => (
            <div key={index} className="flex items-center justify-center h-12 w-full">
              <img
                src={Array.isArray(logo.src) ? logo.src[0] : logo.src}
                alt={logo.alt}
                className={`max-h-10 max-w-[80px] w-auto object-contain opacity-60 grayscale ${logo.additionalClasses || ""}`}
              />
            </div>
          ))}
        </div>
      </section>

      {/* Desktop: Infinite Scroll Carousel */}
      <div className="hidden md:block w-screen relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] border-t border-b border-muted-foreground/10 py-6 overflow-hidden bg-background">
        <div className="absolute left-0 top-0 bottom-0 w-[10%] bg-gradient-to-r from-background to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-[10%] bg-gradient-to-l from-background to-transparent z-10 pointer-events-none" />
        <motion.div
          className="flex animate-infinite-scroll hover:animation-paused motion-reduce:animate-none"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.35, delay: 1.85, ease: "easeOut" }}
        >
          {[0, 1].map((set) => (
            <div key={set} className="flex items-center shrink-0">
              {INTEGRATION_LOGOS.map((logo, index) => (
                <div key={`${set}-${index}`} className="mx-8 shrink-0">
                  <IntegrationLogo
                    src={logo.src}
                    alt={logo.alt}
                    label={logo.label}
                    labelFont={logo.labelFont}
                    additionalClasses={logo.additionalClasses}
                    height="h-12"
                  />
                </div>
              ))}
            </div>
          ))}
        </motion.div>
      </div>
    </>
  );
};
